module.exports = __webpack_public_path__ + "static/media/ref.d4527f77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/generalInformation/ref.svg
// module id = 300
// module chunks = 0